import React, { Component } from 'react';
import styled from 'styled-components';
import { colors } from '../utils/helpers';

export default class Pasos extends Component {
	render() {
		const ContenedorPasos = styled.div``;

		const Clave = styled.h4`
			display: block;
			margin: 0;
			padding-top: 0.8em;
		`;

		const SubCont = styled.div`
			padding: 1em 0 1em 0;
			margin-bottom: 0.1em;
			border-bottom: 1px solid ${colors.grisclaro};
		`;

		const ClaveSmall = styled.span`
			display: inline-block;
			font-weight: 300;
			margin: 0;
			padding-bottom: 1em;
			padding-left: 0.2em;
		`;

		return (
			<ContenedorPasos>
				<SubCont>
					<Clave>
						{this.props.pasos}
						<ClaveSmall>{this.props.pasos > 1 ? ' pasos' : ' paso'}</ClaveSmall>
					</Clave>
				</SubCont>
				<SubCont>
					<Clave>
						<ClaveSmall>{'Recorrido:'}</ClaveSmall>
						{` ${(
							this.props.distancia[0] + this.props.distancia[1]
						).toLocaleString()}  m.`}
					</Clave>
				</SubCont>
				<SubCont>
					{[...Array(this.props.penitentes)].map((e, i) => (
						<svg key={'svg1' + i} height="14" width="14">
							<circle fill={colors.grafica} cx="5" cy="5" r="5" />
						</svg>
					))}
					<Clave>
						{this.props.penitentes}
						<ClaveSmall>{' penitentes'}</ClaveSmall>
					</Clave>
				</SubCont>
				<SubCont>
					{[...Array(this.props.cargadores)].map((e, i) => (
						<svg key={'svg2' + i} height="14" width="14">
							<circle fill={colors.ss} cx="5" cy="5" r="5" />
						</svg>
					))}
					<Clave>
						{this.props.cargadores}
						<ClaveSmall>{' cargadores'}</ClaveSmall>
					</Clave>
				</SubCont>
			</ContenedorPasos>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Pasos.js